import { createAction } from 'redux-actions';
import createErrorAction from 'ui-forms-editor-automation-lib/utils/createErrorAction';
import getFlowUsagesRequestState from 'ui-forms-editor-automation-lib/selectors/flowUsages/getFlowUsagesRequestState';
import getFlowUsages from 'ui-forms-editor-automation-lib/api/getFlowUsages';
export const REQUEST_FLOW_USAGES = '@@lib/REQUEST_FLOW_USAGES';
export const RECEIVE_FLOW_USAGES = '@@lib/RECEIVE_FLOW_USAGES';
export const FAIL_GETTING_FLOW_USAGES = '@@lib/FAIL_GETTING_FLOW_USAGES';
export const requestFlowUsages = createAction(REQUEST_FLOW_USAGES);
export const receiveFlowUsages = createAction(RECEIVE_FLOW_USAGES);
export const failGettingFlowUsages = createAction(FAIL_GETTING_FLOW_USAGES);
export const failGettingFlowUsagesWithError = createErrorAction(FAIL_GETTING_FLOW_USAGES, 'automationLib.errorMessages.failReceivingFlowUsages');
const fetchFlowUsages = formGuid => (dispatch, getState) => {
  const state = getState();
  const requestState = getFlowUsagesRequestState(state);
  if (!requestState.shouldBeRequested()) {
    return Promise.resolve();
  }
  dispatch(requestFlowUsages(formGuid));
  return getFlowUsages(formGuid).then(flowUsages => {
    dispatch(receiveFlowUsages(flowUsages));
  }).catch(error => {
    switch (error.status) {
      case 403:
        dispatch(failGettingFlowUsages(error));
        break;
      default:
        dispatch(failGettingFlowUsagesWithError(error));
        break;
    }
  });
};
export default fetchFlowUsages;